import { toastError } from 'components/ToastComponent/ToastComponent'
import * as providers from './provider'
import { serializeProperty } from './selectors'

export default (setProperty, setError) => {
  const setCurrentProperty = (newId, preview) =>
    setProperty(prev => ({ ...prev, id: newId, preview }))

  const setPropertyData = data => setProperty(prev => ({ ...prev, data }))

  const setPropertyLoading = value =>
    setProperty(prev => ({ ...prev, loadingProperty: value }))

  const clearPropertyData = () => {
    setProperty(prev => ({
      ...prev,
      id: null,
      data: null,
      loadingProperty: false,
    }))
  }

  const fetchProperty = async (id, preview) => {
    if (!id) {
      return null
    }

    const data = await providers.fetchProperty(id, preview)
    const serializedData = data && serializeProperty(data)

    if (serializedData && serializedData.error) {
      toastError('Erro ao buscar informações.')
      return setError(serializedData.code)
    }

    return setPropertyData(serializedData)
  }

  return {
    setCurrentProperty,
    fetchProperty,
    setPropertyLoading,
    clearPropertyData,
  }
}
